// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#inline-rent[data-v-09ccdab8]{max-height:calc(100vh - 4rem)}", "",{"version":3,"sources":["webpack://./resources/js/components/Rent.vue"],"names":[],"mappings":"AACA,8BACI,6BAAJ","sourcesContent":["\n#inline-rent\n    max-height: calc(100vh - 4rem)\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
